import axios from 'axios'

// initial state
const state = () => ({
  result: [],
  count: -1,
  resultTpass: []
})

// getters
const getters = {}

// actions
const actions = {
  Query ({ commit }, value) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/Products/Query', value)
        .then(response => {
          commit('Query', response.data)
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.message)
          reject(error)
        })
    })
  },
  QueryTpass ({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/Products/QueryTpass')
        .then(response => {
          commit('QueryTpass', response.data)
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.message)
          reject(error)
        })
    })
  },
  Clear ({ commit }, value) {
    commit('Clear', [])
  },
  // 單筆查詢
  Detail ({ commit }, value) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/Products/Detail', value)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.message)
          reject(error)
        })
    })
  }
}

// mutations
const mutations = {
  Query (state, value) {
    state.result = value.Data
    state.count = value.PageCount
  },
  QueryTpass (state, value) {
    state.resultTpass = value
  },
  Clear (state) {
    state.result = []
    state.count = -1
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
